// Tijdweergave: altijd ss.mmm of m:ss.mmm
export function fmtTime(ms) {
  if (ms == null || isNaN(ms)) return '–';
  const s = ms / 1000;
  if (s >= 60) {
    const m   = Math.floor(s / 60);
    const rem = (s % 60).toFixed(3).padStart(6, '0');
    return `${m}:${rem}`;
  }
  return s.toFixed(3) + 's';
}

export function fmtSpeed(kmh) {
  if (!kmh || kmh <= 0) return '–';
  return kmh.toFixed(1) + ' km/h';
}

export function fmtDelta(ms) {
  if (ms == null) return '–';
  if (ms === 0) return '–';
  return (ms > 0 ? '+' : '') + (ms / 1000).toFixed(3) + 's';
}

export function fmtTimeOfDay(isoStr) {
  if (!isoStr) return '–';
  return new Date(isoStr).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
}

export function fmtDuration(fromIso, toIso) {
  if (!fromIso || !toIso) return '–';
  const ms  = new Date(toIso) - new Date(fromIso);
  const min = Math.round(ms / 60000);
  return `${min} min`;
}

export function fmtDate(isoStr) {
  if (!isoStr) return '–';
  return new Date(isoStr).toLocaleDateString('nl-NL', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
}

export function fmtDateShort(isoStr) {
  if (!isoStr) return '–';
  return new Date(isoStr + 'T00:00:00').toLocaleDateString('nl-NL', {
    weekday: 'short', day: 'numeric', month: 'short',
  });
}
